import { render, staticRenderFns } from "./_guideId.vue?vue&type=template&id=5361b4b2&scoped=true&"
import script from "./_guideId.vue?vue&type=script&lang=js&"
export * from "./_guideId.vue?vue&type=script&lang=js&"
import style0 from "./_guideId.vue?vue&type=style&index=0&id=5361b4b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5361b4b2",
  null
  
)

export default component.exports